"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var sdk_1 = require("@uniswap/sdk");
var utils_1 = require("ethers/lib/utils");
var bignumber_1 = require("../utils/bignumber");
var provider_1 = require("../utils/provider");
var constants_1 = require("../constants");
var uniswap_1 = require("../utils/uniswap");
var ONE = sdk_1.JSBI.BigInt(1);
var multicall_1 = require("../multicall");
var gas_price_1 = require("../utils/gas-price");
var Minter = /** @class */ (function () {
    function Minter(provider, network, inputTokens, poolTokens, helper) {
        this.provider = provider;
        this.network = network;
        this.inputTokens = inputTokens;
        this.poolTokens = poolTokens;
        this.helper = helper;
        this.pairs = [];
        this.userBalances = {};
        this.userAllowances = {};
        var prom = Promise.all([
            this.setPairsInitial(),
            this.updateUserBalances()
        ]).then(function () { });
        this.waitForUpdate = prom;
    }
    Object.defineProperty(Minter.prototype, "userAddress", {
        get: function () {
            return this.helper.userAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Minter.prototype, "timestamp", {
        get: function () {
            return new Date().getTime() / 1000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Minter.prototype, "shouldUpdate", {
        get: function () {
            return this.timestamp - this.lastUpdateTime > 120;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Minter.prototype, "wethAddress", {
        get: function () {
            return constants_1.getWethAddress(this.network);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Minter.prototype, "minterAddress", {
        get: function () {
            return this.network === 'mainnet' ? '0xfb6Ac20d38A1F0C4f90747CA0745E140bc17E4C3' : '0x5A8a169a86A63741A769de61E258848746A84094';
        },
        enumerable: false,
        configurable: true
    });
    Minter.prototype.getGasPrice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var curProm, newProm;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.timestamp - (this.lastGasPriceUpdate || 0) >= 60) {
                            this.lastGasPriceUpdate = this.timestamp;
                            curProm = this.waitForUpdate;
                            newProm = gas_price_1.getGasPrice(this.network).then(function (price) { return _this.lastGasPrice = price; });
                            this.waitForUpdate = Promise.all([curProm, newProm]).then(function () { });
                        }
                        return [4 /*yield*/, this.waitForUpdate];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.lastGasPrice];
                }
            });
        });
    };
    Minter.prototype.canMintSingle_PoolAmountOut = function (poolToken, poolAmountOut) {
        return __awaiter(this, void 0, void 0, function () {
            var poolRatio, extrapolatedValue, roughEstimate, maxAmountIn, amountIn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        poolRatio = poolAmountOut.div(this.helper.pool.totalSupply);
                        extrapolatedValue = this.helper.extrapolateValue(poolToken);
                        roughEstimate = extrapolatedValue.times(poolRatio);
                        maxAmountIn = this.helper.getTokenByAddress(poolToken).usedBalance.div(2);
                        if (roughEstimate.gt(maxAmountIn))
                            return [2 /*return*/, { canMint: false }];
                        return [4 /*yield*/, this.helper.calcSingleInGivenPoolOut(poolToken, poolAmountOut)];
                    case 1:
                        amountIn = _a.sent();
                        if (bignumber_1.toBN(amountIn.amount).gt(maxAmountIn))
                            return [2 /*return*/, { canMint: false }];
                        return [2 /*return*/, { canMint: true, amountIn: amountIn }];
                }
            });
        });
    };
    Minter.prototype.updateUserBalances = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userData, i, address, _a, balance, allowance, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.userAddress)
                            return [2 /*return*/];
                        return [4 /*yield*/, multicall_1.getTokenUserData(this.provider, this.userAddress, this.minterAddress, this.inputTokens)];
                    case 1:
                        userData = _d.sent();
                        for (i = 0; i < this.inputTokens.length; i++) {
                            address = this.inputTokens[i].address.toLowerCase();
                            _a = userData[i], balance = _a.balance, allowance = _a.allowance;
                            this.userAllowances[address] = allowance;
                            this.userBalances[address] = balance;
                        }
                        this.userAllowances[constants_1.zeroAddress] = new bignumber_1.BigNumber(0);
                        _b = this.userBalances;
                        _c = constants_1.zeroAddress;
                        return [4 /*yield*/, this.provider.getBalance(this.userAddress).then(bignumber_1.toBN)];
                    case 2:
                        _b[_c] = _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Minter.prototype.getUserTokenData = function (token) {
        if (!this.userAddress || !this.userAllowances[token.toLowerCase()])
            return {};
        return {
            balance: this.userBalances[token.toLowerCase()],
            allowance: this.userAllowances[token.toLowerCase()]
        };
    };
    Minter.prototype.getIndexedTokenAmount = function (address, tokenAmount) {
        var _a;
        var symbol, decimals;
        if (address == constants_1.zeroAddress) {
            symbol = 'ETH';
            decimals = 18;
        }
        else {
            (_a = tokenAmount.currency, symbol = _a.symbol, decimals = _a.decimals);
        }
        var amount = uniswap_1.bigintToHex(tokenAmount.raw);
        var displayAmount = bignumber_1.formatBalance(bignumber_1.toBN(amount), decimals, 4);
        var obj = {
            address: address,
            symbol: symbol,
            decimals: decimals,
            amount: amount,
            displayAmount: displayAmount
        };
        var tokenInfo = this.getUserTokenData(address);
        if (tokenInfo.allowance) {
            var balance = tokenInfo.balance, allowance = tokenInfo.allowance;
            obj.balance = bignumber_1.toHex(balance);
            obj.allowance = bignumber_1.toHex(allowance);
            if (allowance.lt(bignumber_1.toBN(amount))) {
                obj.remainingApprovalAmount = bignumber_1.toHex(bignumber_1.toBN(amount).minus(allowance));
            }
        }
        return obj;
    };
    Minter.prototype.getSinglePair = function (tokenA, tokenB) {
        var a = utils_1.getAddress(tokenA);
        var b = utils_1.getAddress(tokenB);
        return this.pairs.find(function (p) { return ((a == p.token0.address && b == p.token1.address) ||
            (b == p.token0.address && a == p.token1.address)); });
    };
    Minter.prototype.getTokenByAddress = function (address) {
        return __spreadArrays(this.inputTokens, this.poolTokens).find(function (t) { return t.address.toLowerCase() == address.toLowerCase(); });
    };
    Minter.prototype.getTokenAmount = function (address, amount) {
        var token = this.getTokenByAddress(address);
        if (!token)
            throw Error("Could not find token " + address);
        return new sdk_1.TokenAmount(token, amount);
    };
    Minter.prototype.getPoolTokenAmount = function (helper, amountHex) {
        return new sdk_1.TokenAmount(new sdk_1.Token(this.network === 'mainnet' ? 1 : 4, utils_1.getAddress(helper.address), 18, helper.pool.symbol, helper.pool.name), bignumber_1.toBN(amountHex).toString(10));
    };
    Minter.prototype.setPairsInitial = function () {
        return __awaiter(this, void 0, void 0, function () {
            var allTokens, pairs, i, tokenA, j, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        allTokens = __spreadArrays(this.inputTokens, this.poolTokens);
                        pairs = [];
                        for (i = 0; i < allTokens.length; i++) {
                            tokenA = allTokens[i];
                            for (j = i + 1; j < allTokens.length; j++) {
                                pairs.push(uniswap_1.getPair(this.provider, tokenA, allTokens[j]));
                            }
                        }
                        _a = this;
                        return [4 /*yield*/, Promise.all(pairs)];
                    case 1:
                        _a.pairs = (_b.sent()).filter(function (x) { return x; });
                        this.lastUpdateTime = this.timestamp;
                        return [2 /*return*/];
                }
            });
        });
    };
    Minter.prototype.updatePairs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pairs, i, pair, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        pairs = [];
                        for (i = 0; i < this.pairs.length; i++) {
                            pair = this.pairs[i];
                            pairs.push(sdk_1.Fetcher.fetchPairData(pair.token0, pair.token1, this.provider).catch(function () { }));
                        }
                        _a = this;
                        return [4 /*yield*/, Promise.all(pairs)];
                    case 1: return [4 /*yield*/, (_b.sent())];
                    case 2:
                        _a.pairs = _b.sent();
                        this.lastUpdateTime = this.timestamp;
                        return [2 /*return*/];
                }
            });
        });
    };
    Minter.prototype.update = function () {
        if (!this.pairs.length) {
            return this.waitForUpdate;
        }
        if (this.shouldUpdate) {
            var prom = Promise.all([
                this.updatePairs(),
                this.updateUserBalances()
            ]).then(function () { });
            this.waitForUpdate = prom;
        }
        return this.waitForUpdate;
    };
    Minter.prototype.bestTradeExactIn = function (tokenIn, amountIn_, tokenOut_, options) {
        return __awaiter(this, void 0, void 0, function () {
            var amountIn, tokenOut, trades;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.update()];
                    case 1:
                        _a.sent();
                        amountIn = this.getTokenAmount(tokenIn, amountIn_);
                        tokenOut = this.getTokenByAddress(tokenOut_);
                        return [4 /*yield*/, sdk_1.Trade.bestTradeExactIn(this.pairs, amountIn, tokenOut, options)];
                    case 2:
                        trades = _a.sent();
                        return [2 /*return*/, trades[0]];
                }
            });
        });
    };
    Minter.prototype.bestTradeExactOut = function (tokenIn_, tokenOut, amountOut_, options) {
        return __awaiter(this, void 0, void 0, function () {
            var amountOut, tokenIn, trades;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.update()];
                    case 1:
                        _a.sent();
                        amountOut = this.getTokenAmount(tokenOut, amountOut_);
                        tokenIn = this.getTokenByAddress(tokenIn_);
                        return [4 /*yield*/, sdk_1.Trade.bestTradeExactOut(this.pairs, tokenIn, amountOut, options)];
                    case 2:
                        trades = _a.sent();
                        return [2 /*return*/, trades[0]];
                }
            });
        });
    };
    Minter.prototype.getCheapestSingleInput = function (poolAmountOut, tokenIn) {
        return __awaiter(this, void 0, void 0, function () {
            var helper, allTokens, proms, _i, allTokens_1, token, res, allSingleAmounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        helper = this.helper;
                        allTokens = helper.tokens;
                        if (tokenIn) {
                            allTokens = allTokens.filter(function (t) { return t.address.toLowerCase() !== tokenIn.toLowerCase(); });
                        }
                        proms = [];
                        for (_i = 0, allTokens_1 = allTokens; _i < allTokens_1.length; _i++) {
                            token = allTokens_1[_i];
                            proms.push(this.canMintSingle_PoolAmountOut(token.address, bignumber_1.toBN(poolAmountOut)));
                        }
                        return [4 /*yield*/, Promise.all(proms)];
                    case 1:
                        res = (_a.sent()).filter(function (r) { return r.canMint; }).map(function (r) { return r.amountIn; });
                        allSingleAmounts = res.map(function (input) { return (__assign(__assign({}, input), { cost: parseFloat(bignumber_1.formatBalance(bignumber_1.toBN(input.amount), input.decimals, 10)) * helper.getTokenByAddress(input.address).priceUSD })); });
                        return [2 /*return*/, allSingleAmounts.filter(function (amount) { return bignumber_1.toBN(amount.amount).lt(helper.getTokenByAddress(amount.address).usedBalance.div(2)); }).sort(function (a, b) { return a.cost - b.cost; })[0]];
                }
            });
        });
    };
    Minter.prototype.getMaximumOutputForSingleInput = function (tokenIn, tokenAmountIn, options) {
        return __awaiter(this, void 0, void 0, function () {
            var slippage, helper, proms, getPoolOut, allTokens, _i, allTokens_2, token, allOutputs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        slippage = new sdk_1.Fraction(((options && options.slippage) || 2).toString(), '100');
                        helper = this.helper;
                        proms = [];
                        getPoolOut = function (poolTokenIn) { return __awaiter(_this, void 0, void 0, function () {
                            var bestTrade, amount, poolOut;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.bestTradeExactIn(tokenIn, tokenAmountIn, poolTokenIn.address, options)];
                                    case 1:
                                        bestTrade = _a.sent();
                                        amount = bignumber_1.toBN('0x' + bestTrade.minimumAmountOut(slippage).raw.toString(16));
                                        if (!amount.gt(poolTokenIn.usedBalance.div(2))) return [3 /*break*/, 3];
                                        return [4 /*yield*/, this.bestTradeExactOut(tokenIn, poolTokenIn.address, bignumber_1.toHex(poolTokenIn.usedBalance.div(2)), options)];
                                    case 2:
                                        bestTrade = _a.sent();
                                        amount = bignumber_1.toBN('0x' + bestTrade.minimumAmountOut(slippage).raw.toString(16));
                                        _a.label = 3;
                                    case 3: return [4 /*yield*/, helper.calcPoolOutGivenSingleIn(poolTokenIn.address, amount)];
                                    case 4:
                                        poolOut = _a.sent();
                                        return [2 /*return*/, {
                                                trade: bestTrade,
                                                poolAmount: poolOut
                                            }];
                                }
                            });
                        }); };
                        allTokens = helper.tokens;
                        for (_i = 0, allTokens_2 = allTokens; _i < allTokens_2.length; _i++) {
                            token = allTokens_2[_i];
                            proms.push(getPoolOut(token));
                        }
                        return [4 /*yield*/, Promise.all(proms)];
                    case 1:
                        allOutputs = _a.sent();
                        return [2 /*return*/, allOutputs.sort(function (a, b) { return bignumber_1.toBN(b.poolAmount.amount).minus(bignumber_1.toBN(a.poolAmount.amount)).toNumber(); })[0]];
                }
            });
        });
    };
    Minter.prototype.getBestParams_ExactTokenForTokens = function (tokenIn, tokenAmountIn, options) {
        return __awaiter(this, void 0, void 0, function () {
            var slippage, maximumOutput, helper, poolOutput, slippageAdjustedAmountOut, tokenInput, minPoolOutput;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        slippage = new sdk_1.Fraction(((options && options.slippage) || 2).toString(), '100');
                        return [4 /*yield*/, this.getMaximumOutputForSingleInput(tokenIn, tokenAmountIn, options)];
                    case 1:
                        maximumOutput = _a.sent();
                        helper = this.helper;
                        poolOutput = this.getPoolTokenAmount(helper, maximumOutput.poolAmount.amount);
                        slippageAdjustedAmountOut = new sdk_1.Fraction(ONE)
                            .add(slippage)
                            .invert()
                            .multiply(poolOutput.raw).quotient;
                        tokenInput = this.getIndexedTokenAmount(tokenIn, this.getTokenAmount(tokenIn, tokenAmountIn));
                        minPoolOutput = this.getIndexedTokenAmount(this.helper.address, this.getPoolTokenAmount(helper, '0x' + slippageAdjustedAmountOut.toString(16)));
                        return [2 /*return*/, {
                                fn: 'swapExactTokensForTokensAndMint',
                                tokenInput: tokenInput,
                                minPoolOutput: minPoolOutput,
                                path: maximumOutput.trade.route.path.map(function (t) { return t.address; })
                            }];
                }
            });
        });
    };
    Minter.prototype.getBestParams_ExactEthForTokens = function (ethAmountIn, options) {
        return __awaiter(this, void 0, void 0, function () {
            var slippage, maximumOutput, helper, poolOutput, slippageAdjustedAmountOut, ethInput, minPoolOutput;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        slippage = new sdk_1.Fraction(((options && options.slippage) || 2).toString(), '100');
                        return [4 /*yield*/, this.getMaximumOutputForSingleInput(this.wethAddress, ethAmountIn, options)];
                    case 1:
                        maximumOutput = _a.sent();
                        helper = this.helper;
                        poolOutput = this.getPoolTokenAmount(helper, maximumOutput.poolAmount.amount);
                        slippageAdjustedAmountOut = new sdk_1.Fraction(ONE)
                            .add(slippage)
                            .invert()
                            .multiply(poolOutput.raw).quotient;
                        ethInput = this.getIndexedTokenAmount(constants_1.zeroAddress, this.getTokenAmount(this.wethAddress, ethAmountIn));
                        minPoolOutput = this.getIndexedTokenAmount(this.helper.address, this.getPoolTokenAmount(helper, '0x' + slippageAdjustedAmountOut.toString(16)));
                        return [2 /*return*/, {
                                fn: 'swapExactETHForTokensAndMint',
                                ethInput: ethInput,
                                minPoolOutput: minPoolOutput,
                                path: maximumOutput.trade.route.path.map(function (t) { return t.address; })
                            }];
                }
            });
        });
    };
    Minter.prototype.getParams_EthForExactPoolTokens = function (poolAmountOut, options) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenIn, slippage, cheapestInput, bestTrade, helper, poolOutput, maxEthInput;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokenIn = this.wethAddress;
                        slippage = new sdk_1.Fraction(((options && options.slippage) || 2).toString(), '100');
                        return [4 /*yield*/, this.getCheapestSingleInput(poolAmountOut, this.wethAddress)];
                    case 1:
                        cheapestInput = _a.sent();
                        if (!cheapestInput) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.bestTradeExactOut(tokenIn, cheapestInput.address, cheapestInput.amount, options)];
                    case 2:
                        bestTrade = _a.sent();
                        helper = this.helper;
                        poolOutput = this.getIndexedTokenAmount(this.helper.address, this.getPoolTokenAmount(helper, poolAmountOut));
                        maxEthInput = this.getIndexedTokenAmount(constants_1.zeroAddress, this.getTokenAmount(tokenIn, bestTrade.maximumAmountIn(slippage).raw));
                        return [2 /*return*/, {
                                fn: 'swapETHForTokensAndMintExact',
                                poolOutput: poolOutput,
                                maxEthInput: maxEthInput,
                                path: bestTrade.route.path.map(function (t) { return t.address; })
                            }];
                }
            });
        });
    };
    Minter.prototype.getParams_TokensForExactPoolTokens = function (tokenIn, poolAmountOut, options) {
        return __awaiter(this, void 0, void 0, function () {
            var slippage, cheapestInput, bestTrade, helper, poolOutput, maxTokenInput;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        slippage = new sdk_1.Fraction(((options && options.slippage) || 2).toString(), '100');
                        return [4 /*yield*/, this.getCheapestSingleInput(poolAmountOut, tokenIn)];
                    case 1:
                        cheapestInput = _a.sent();
                        if (!cheapestInput)
                            return [2 /*return*/, null];
                        return [4 /*yield*/, this.bestTradeExactOut(tokenIn, cheapestInput.address, cheapestInput.amount, options)];
                    case 2:
                        bestTrade = _a.sent();
                        helper = this.helper;
                        poolOutput = this.getIndexedTokenAmount(this.helper.address, this.getPoolTokenAmount(helper, poolAmountOut));
                        maxTokenInput = this.getIndexedTokenAmount(tokenIn, this.getTokenAmount(tokenIn, bestTrade.maximumAmountIn(slippage).raw));
                        return [2 /*return*/, {
                                fn: 'swapTokensForTokensAndMintExact',
                                poolOutput: poolOutput,
                                maxTokenInput: maxTokenInput,
                                path: bestTrade.route.path.map(function (t) { return t.address; })
                            }];
                }
            });
        });
    };
    Minter.prototype.getMaxCostSingleInput = function (tokenIn, tokenOut, amountOut, slippage) {
        var pair = this.getSinglePair(tokenIn, tokenOut);
        var trade = sdk_1.Trade.exactOut(new sdk_1.Route([pair], this.getTokenByAddress(tokenIn), this.getTokenByAddress(tokenOut)), this.getTokenAmount(tokenIn, amountOut));
        return this.getTokenAmount(tokenIn, trade.maximumAmountIn(slippage).raw);
    };
    Minter.prototype.getMostLiquidPairedToken = function (token) {
        var pairsWithToken = this.pairs.filter(function (p) { return (p.token0.address.toLowerCase() === token.toLowerCase() ||
            p.token1.address.toLowerCase() === token.toLowerCase()); }).sort(function (a, b) {
            var reserveA = a.token0.address.toLowerCase() === token.toLowerCase() ?
                a.reserve0 : a.reserve1;
            var reserveB = b.token0.address.toLowerCase() === token.toLowerCase() ?
                b.reserve0 : b.reserve1;
            return reserveB.greaterThan(reserveA) ? 1 : -1;
        });
        var bestpair = pairsWithToken[0];
        var pairedToken = bestpair.token0.address.toLowerCase() === token.toLowerCase() ?
            bestpair.token1.address : bestpair.token0.address;
        return pairedToken;
    };
    Minter.prototype.getParams_TokenForAllTokens = function (tokenIn, poolAmountOut, options) {
        return __awaiter(this, void 0, void 0, function () {
            var slippage, helper, amountsIn, amountInTotal, intermediaries, maxTokenInput, poolOutput;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        slippage = new sdk_1.Fraction(((options && options.slippage) || 2).toString(), '100');
                        helper = this.helper;
                        return [4 /*yield*/, helper.calcAllInGivenPoolOut(poolAmountOut)];
                    case 1:
                        amountsIn = _a.sent();
                        amountInTotal = this.getTokenAmount(tokenIn, '0');
                        return [4 /*yield*/, Promise.all(amountsIn.map(function (amount, i) { return __awaiter(_this, void 0, void 0, function () {
                                var pairedToken, trade1, trade0, bestTrade, err_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(amount.address.toLowerCase() === tokenIn.toLowerCase())) return [3 /*break*/, 3];
                                            pairedToken = this.getMostLiquidPairedToken(tokenIn);
                                            return [4 /*yield*/, this.bestTradeExactOut(pairedToken, tokenIn, amount.amount, { maxHops: 1 })];
                                        case 1:
                                            trade1 = _a.sent();
                                            return [4 /*yield*/, this.bestTradeExactOut(tokenIn, pairedToken, trade1.inputAmount.raw.toString(10), { maxHops: 1 })];
                                        case 2:
                                            trade0 = _a.sent();
                                            amountInTotal = amountInTotal.add(trade0.maximumAmountIn(slippage));
                                            return [2 /*return*/, pairedToken];
                                        case 3:
                                            _a.trys.push([3, 5, , 6]);
                                            return [4 /*yield*/, this.bestTradeExactOut(tokenIn, amount.address, amount.amount, { maxHops: 2 })];
                                        case 4:
                                            bestTrade = _a.sent();
                                            amountInTotal = amountInTotal.add(bestTrade.maximumAmountIn(slippage));
                                            if (bestTrade.route.path.length != 2) {
                                                return [2 /*return*/, bestTrade.route.path[1].address];
                                            }
                                            return [2 /*return*/, constants_1.zeroAddress];
                                        case 5:
                                            err_1 = _a.sent();
                                            console.log(tokenIn);
                                            console.log(amount.address);
                                            throw err_1;
                                        case 6: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        intermediaries = _a.sent();
                        maxTokenInput = this.getIndexedTokenAmount(tokenIn, amountInTotal);
                        poolOutput = this.getIndexedTokenAmount(this.helper.address, this.getPoolTokenAmount(helper, poolAmountOut));
                        return [2 /*return*/, {
                                fn: 'swapTokensForAllTokensAndMintExact',
                                maxTokenInput: maxTokenInput,
                                poolOutput: poolOutput,
                                intermediaries: intermediaries
                            }];
                }
            });
        });
    };
    Minter.prototype.getParams_EthForAllTokens = function (poolAmountOut, options) {
        return __awaiter(this, void 0, void 0, function () {
            var slippage, helper, amountsIn, amountInTotal, trades, intermediaries, maxEthInput, poolOutput;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        slippage = new sdk_1.Fraction(((options && options.slippage) || 2).toString(), '100');
                        helper = this.helper;
                        return [4 /*yield*/, helper.calcAllInGivenPoolOut(poolAmountOut)];
                    case 1:
                        amountsIn = _a.sent();
                        amountInTotal = this.getTokenAmount(this.wethAddress, '0');
                        trades = [];
                        return [4 /*yield*/, Promise.all(amountsIn.map(function (amount) { return __awaiter(_this, void 0, void 0, function () {
                                var pairedToken, trade1, trade0, bestTrade;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(amount.address.toLowerCase() === this.wethAddress.toLowerCase())) return [3 /*break*/, 3];
                                            pairedToken = this.getMostLiquidPairedToken(this.wethAddress);
                                            return [4 /*yield*/, this.bestTradeExactOut(pairedToken, this.wethAddress, amount.amount, { maxHops: 1 })];
                                        case 1:
                                            trade1 = _a.sent();
                                            return [4 /*yield*/, this.bestTradeExactOut(this.wethAddress, pairedToken, trade1.inputAmount.raw.toString(10), { maxHops: 1 })];
                                        case 2:
                                            trade0 = _a.sent();
                                            amountInTotal = amountInTotal.add(trade0.maximumAmountIn(slippage));
                                            return [2 /*return*/, pairedToken];
                                        case 3: return [4 /*yield*/, this.bestTradeExactOut(this.wethAddress, amount.address, amount.amount, { maxHops: 2 })];
                                        case 4:
                                            bestTrade = _a.sent();
                                            amountInTotal = amountInTotal.add(bestTrade.maximumAmountIn(slippage));
                                            if (bestTrade.route.path.length != 2) {
                                                return [2 /*return*/, bestTrade.route.path[1].address];
                                            }
                                            return [2 /*return*/, constants_1.zeroAddress];
                                    }
                                });
                            }); }))];
                    case 2:
                        intermediaries = _a.sent();
                        maxEthInput = this.getIndexedTokenAmount(constants_1.zeroAddress, amountInTotal);
                        poolOutput = this.getIndexedTokenAmount(this.helper.address, this.getPoolTokenAmount(helper, poolAmountOut));
                        return [2 /*return*/, {
                                params: {
                                    fn: 'swapETHForAllTokensAndMintExact',
                                    maxEthInput: maxEthInput,
                                    poolOutput: poolOutput,
                                    intermediaries: intermediaries
                                },
                                trades: trades
                            }];
                }
            });
        });
    };
    Minter.prototype.getBestParams_EthForPoolExact = function (poolAmountOut, options) {
        return __awaiter(this, void 0, void 0, function () {
            var all, single, ethSingle, ethAll, gasPrice, roughSingleGas, roughAllGas, roughCostAll;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getParams_EthForAllTokens(poolAmountOut, options)];
                    case 1:
                        all = _a.sent();
                        return [4 /*yield*/, this.getParams_EthForExactPoolTokens(poolAmountOut, options)];
                    case 2:
                        single = _a.sent();
                        if (!single) return [3 /*break*/, 4];
                        ethSingle = bignumber_1.toBN(single.maxEthInput.amount);
                        ethAll = bignumber_1.toBN(all.params.maxEthInput.amount);
                        if (ethSingle.lt(ethAll)) {
                            return [2 /*return*/, single];
                        }
                        if (!(options === null || options === void 0 ? void 0 : options.compareGasPrice)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getGasPrice()];
                    case 3:
                        gasPrice = _a.sent();
                        roughSingleGas = 300000;
                        roughAllGas = this.poolTokens.length * 220000;
                        roughCostAll = (roughAllGas - roughSingleGas) * gasPrice;
                        ethAll = ethAll.plus(roughCostAll);
                        if (ethSingle.lt(ethAll))
                            return [2 /*return*/, single];
                        _a.label = 4;
                    case 4: return [2 /*return*/, all.params];
                }
            });
        });
    };
    Minter.prototype.getBestParams_TokensForPoolExact = function (tokenIn, poolAmountOut, options) {
        return __awaiter(this, void 0, void 0, function () {
            var all, single, tokenSingle, tokenAll, gasPrice, roughSingleGas, roughAllGas, roughCostAll, tokenValue, bnValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getParams_TokenForAllTokens(tokenIn, poolAmountOut, options && { slippage: options.slippage })];
                    case 1:
                        all = _a.sent();
                        return [4 /*yield*/, this.getParams_TokensForExactPoolTokens(tokenIn, poolAmountOut, options)];
                    case 2:
                        single = _a.sent();
                        if (!single) return [3 /*break*/, 5];
                        tokenSingle = bignumber_1.toBN(single.maxTokenInput.amount);
                        tokenAll = bignumber_1.toBN(all.maxTokenInput.amount);
                        if (tokenSingle.lt(tokenAll)) {
                            return [2 /*return*/, single];
                        }
                        if (!(options === null || options === void 0 ? void 0 : options.compareGasPrice)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getGasPrice()];
                    case 3:
                        gasPrice = _a.sent();
                        roughSingleGas = 300000;
                        roughAllGas = this.poolTokens.length * 220000;
                        roughCostAll = (roughAllGas - roughSingleGas) * gasPrice;
                        return [4 /*yield*/, this.bestTradeExactIn(this.wethAddress, roughCostAll.toString(), tokenIn)];
                    case 4:
                        tokenValue = _a.sent();
                        bnValue = bignumber_1.toBN(uniswap_1.bigintToHex(tokenValue.outputAmount.raw));
                        tokenAll = tokenAll.plus(bnValue);
                        if (tokenSingle.lt(tokenAll))
                            return [2 /*return*/, single];
                        _a.label = 5;
                    case 5: return [2 /*return*/, all];
                }
            });
        });
    };
    Minter.prototype.getBestParams_ExactTokensForPool = function (tokenIn, tokenAmountIn, options) {
        return __awaiter(this, void 0, void 0, function () {
            var bestSingle, bestMulti;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBestParams_ExactTokenForTokens(tokenIn, tokenAmountIn, options)];
                    case 1:
                        bestSingle = _a.sent();
                        return [4 /*yield*/, this.getParams_TokenForAllTokens(tokenIn, bestSingle.minPoolOutput.amount, options && { slippage: options.slippage })];
                    case 2:
                        bestMulti = _a.sent();
                        if (bignumber_1.toBN(bestSingle.tokenInput.amount).lt(bignumber_1.toBN(bestMulti.maxTokenInput.amount))) {
                            return [2 /*return*/, bestSingle];
                        }
                        else {
                            return [2 /*return*/, bestMulti];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Minter.prototype.getBestParams_ExactEthForPool = function (ethAmountIn, options) {
        return __awaiter(this, void 0, void 0, function () {
            var bestSingle, bestMulti;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBestParams_ExactEthForTokens(ethAmountIn, options)];
                    case 1:
                        bestSingle = _a.sent();
                        return [4 /*yield*/, this.getParams_EthForAllTokens(bestSingle.minPoolOutput.amount, options)];
                    case 2:
                        bestMulti = _a.sent();
                        if (bignumber_1.toBN(bestSingle.ethInput.amount).lt(bignumber_1.toBN(bestMulti.params.maxEthInput.amount))) {
                            return [2 /*return*/, bestSingle];
                        }
                        else {
                            return [2 /*return*/, bestMulti.params];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Minter.getMinter = function (provider_, chainID, tokenInputs, helper) {
        return __awaiter(this, void 0, void 0, function () {
            var network, provider, weth, poolHasToken;
            return __generator(this, function (_a) {
                network = chainID === 1 ? 'mainnet' : 'rinkeby';
                provider = provider_1.toProvider(provider_);
                weth = constants_1.getWethAddress(network);
                if (!(tokenInputs.find(function (t) { return t.address.toLowerCase() == weth.toLowerCase(); }))) {
                    tokenInputs.push({ name: 'Wrapped Ether', symbol: 'WETH', decimals: 18, address: weth });
                }
                poolHasToken = function (address) { return !!(helper.tokens.find(function (t) { return t.address.toLowerCase() == address.toLowerCase(); })); };
                return [2 /*return*/, new Minter(provider, network, uniswap_1.toTokens(chainID, tokenInputs.filter(function (t) { return !poolHasToken(t.address); })), uniswap_1.toTokens(chainID, helper.tokens), helper)];
            });
        });
    };
    return Minter;
}());
exports.default = Minter;
